import {
  GrpcWebImpl,
  OrgServiceClientImpl,
} from '@mapped/proto-browser/dist/mapped/cloud/api/orgs/orgs';
import {
  SignupServiceClientImpl,
} from '@mapped/proto-browser/dist/mapped/cloud/api/orgs/signup/signup';
import { BrowserHeaders } from 'browser-headers';
import { getSessionAuthToken } from '../auth/auth';

import { Services } from '../services';

function rpc() {
  return new GrpcWebImpl(Services.grpc_services.anaxi, {
    metadata: new BrowserHeaders({
      'X-Mapped-Route-To': Services.grpc_services.orgsMicroEndpoint,
      Authorization: `Bearer ${getSessionAuthToken()}`,
    }),
  });
}

function AllOrgs() {
  return new OrgServiceClientImpl(rpc());
}

function CustomerOrgs() {
  return new SignupServiceClientImpl(rpc());
}

export default {
  AllOrgs,
  CustomerOrgs,
}
